
@switch (columnId) {
  @case ('feeCategory') {
    <lib-text-table-column>
      {{ element.feeCategory }}
    </lib-text-table-column>
  }
  @case ('feeType') {
    <lib-text-table-column>
      {{ element.feeType }}
    </lib-text-table-column>
  }
  @case ('feeValue') {
    <lib-text-table-column>
      {{ element.feeValue | vituCurrencyUsd }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.feeValue ?? 0"></lib-table-column-sort>
  }
  @case ('perc') {
    <lib-text-table-column>
      {{ feePerc | vituPercentage }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="feePerc"></lib-table-column-sort>
  }
  @default {
  }
}





